import { Map, Marker, Overlay } from "pigeon-maps"
import { useState } from "react"
import { Box, CircularProgress } from "@mui/material"
import { useGetStoresQuery } from "../services/elmApi"
import { Store } from "../services/api/types/Store"

function Locations() {
  const { data, error, isLoading } = useGetStoresQuery()

  const pin: [number, number] = [51.5661807, 0.0021723]
  const [overlayRecord, setOverlayRecord] = useState<Store | undefined>(
    undefined,
  )

  const handleMarkerClick = (record: Store) => {
    if (overlayRecord === undefined || overlayRecord !== record) {
      setOverlayRecord(record)
    } else {
      setOverlayRecord(undefined)
    }
  }

  return (
    <div style={{ height: "100vh" }}>
      {error ? (
        <>Error loading records</>
      ) : isLoading ? (
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={100} sx={{ marginTop: "100px" }} />
        </Box>
      ) : data ? (
        <Map defaultCenter={pin} attribution={false} animate={false}>
          {data.records.map((record) => {
            return (
              <Marker
                key={record.uid}
                width={50}
                anchor={[record.latitude, record.longitude]}
                color="#224e3f"
                onClick={() => {
                  handleMarkerClick(record)
                }}
              />
            )
          })}

          {overlayRecord && (
            <Overlay
              anchor={[overlayRecord.latitude, overlayRecord.longitude]}
              offset={[100, -5]}
            >
              <div
                style={{
                  padding: "5px 10px",
                  borderRadius: "5px",
                  backgroundColor: "#224e3f",
                  boxShadow: "0 0 5px rgba(0, 0, 0, 0.3)",
                  color: "white",
                }}
              >
                {overlayRecord.organisation_name} &middot;{" "}
                {overlayRecord.postcode}
              </div>
            </Overlay>
          )}
        </Map>
      ) : null}
    </div>
  )
}

export default Locations
